import React from 'react';
import './Benefits.css';

const Benefits = () => {
  const benefits = [
    {
      title: 'ЭКОНОМЬ ВРЕМЯ',
      description: 'Забудь о часах в поисках тренировок в YouTube. Всё уже структурировано и готово к работе.',
      image: 'https://images.unsplash.com/photo-1461896836934-ffe607ba8211?w=800&q=80'
    },
    {
      title: 'РЕЗУЛЬТАТ ГАРАНТИРОВАН',
      description: 'Наша методика проверена тысячами пользователей. 98% достигают своих целей за 3 месяца.',
      image: 'https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?w=800&q=80'
    },
    {
      title: 'НЕ НУЖЕН ЗАЛ',
      description: 'Тренируйся дома, на улице, в зале — где угодно. Программы адаптируются под твои условия.',
      image: 'https://images.unsplash.com/photo-1517836357463-d25dfeac3438?w=800&q=80'
    },
    {
      title: 'МОТИВАЦИЯ 24/7',
      description: 'Сообщество, челленджи, достижения и AI-коуч — ты никогда не останешься один на этом пути.',
      image: 'https://images.unsplash.com/photo-1549060279-7e168fcee0c2?w=800&q=80'
    }
  ];

  return (
    <section className="benefits section">
      <div className="container">
        <h2 className="section-title">Почему Выбирают FitHousse</h2>
        <div className="benefits-grid">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="benefit-card"
              style={{ animationDelay: `${index * 0.15}s` }}
            >
              <div className="benefit-image-wrapper">
                <img src={benefit.image} alt={benefit.title} className="benefit-image" />
                <div className="benefit-overlay"></div>
              </div>
              <div className="benefit-content">
                <h3 className="benefit-title">{benefit.title}</h3>
                <p className="benefit-description">{benefit.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Benefits;
